// extracted by mini-css-extract-plugin
module.exports = {"Switch":"ContentTab-module--Switch--228q5","Label":"ContentTab-module--Label--bqtRg","Content":"ContentTab-module--Content--AXpgz"};